import React from 'react';
import LoadingSpinner from './LoadingSpinner';

export default class Select extends React.Component {
    constructor(props) {
        super(props);

        this.clear = this.clear.bind(this);
    }

    clear() {
        this.props.onChange({ target: { name: this.props.name, value: '' } });
    }

    getValue() {
        const { allowZero } = this.props;

        if (allowZero && this.props.value === 0)
        return "0"

        return this.props.value || ''
    }

    render() {
        
        return (
            <div className="custom-select">
                <select 
                tabIndex={this.props.tabIndex || ''}
                className={this.props.className}
                name={this.props.name}
                value={this.getValue()}
                onChange={this.props.onChange}
                disabled={this.props.disabled}>
                    {(this.props.placeholder || (this.props.options && this.props.options.length > 0)) &&
                    <option hidden defaultValue>{this.props.placeholder || "Select"}</option>}
                    {this.props.options && this.props.options.map(option => {
                        return option.optionGroup ? <optgroup key={option.label} label={option.label}></optgroup>
                            : <option key={option.key} value={option.key} title={option.details}>{option.value}</option>
                    })}
                </select>
                {(this.props.clearable && !!this.props.value) && <i className="icon ion-ios-close-outline clear-select input" onClick={this.clear}></i>}
                {this.props.loading ? <LoadingSpinner height="12" /> : <i className="icon ion-ios-arrow-down"></i>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/Select.jsx